import { render } from "./DashboardMain.vue?vue&type=template&id=35fb15c5"
import script from "./DashboardMain.js?vue&type=script&lang=js&external"
export * from "./DashboardMain.js?vue&type=script&lang=js&external"

import "./DashboardMain.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__